const URL = {
  APPSUMO_CODE_CONFIRM: 'promoCode/validatePromoCode',
}

export default URL
